/*
 *                     NOTICE
 *            COPYRIGHT 2026 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */

import * as AbReactResources from "abreact/generated/locale/AbReactResources";
import * as React from "react";
/**
 * Renders the content for a data value tooltip for a value that may have server and client changes to show.
 * @param props
 * @constructor
 */
export function AbDataValueTooltipContent(props) {
  if (props.hasServerChange || props.hasClientChange) {
    // We have a tooltip to render
    if (props.hasServerChange && props.hasClientChange) {
      // We have 2 parts we need to show
      return /*#__PURE__*/React.createElement("div", {
        "data-test-id": "ab-data-value-tooltip-content"
      }, /*#__PURE__*/React.createElement("div", {
        "data-test-id": "serverValueLabel"
      }, AbReactResources.field_changeSetValueName()), props.serverValue ? props.valueRenderer(props.serverValue) : /*#__PURE__*/React.createElement("div", null, AbReactResources.field_nullPreviousValue()), /*#__PURE__*/React.createElement("div", {
        "data-test-id": "baselineValueLabel"
      }, AbReactResources.field_baselineValueName()), props.baselineValue ? props.valueRenderer(props.baselineValue) : /*#__PURE__*/React.createElement("div", null, AbReactResources.field_nullPreviousValue()));
    } else if (props.hasServerChange) {
      return /*#__PURE__*/React.createElement("div", {
        "data-test-id": "ab-data-value-tooltip-content"
      }, /*#__PURE__*/React.createElement("div", {
        "data-test-id": "baselineValueLabel"
      }, AbReactResources.field_baselineValueName()), props.baselineValue ? props.valueRenderer(props.baselineValue) : /*#__PURE__*/React.createElement("div", null, AbReactResources.field_nullPreviousValue()));
    } else if (props.hasClientChange) {
      return /*#__PURE__*/React.createElement("div", {
        "data-test-id": "ab-data-value-tooltip-content"
      }, /*#__PURE__*/React.createElement("div", {
        "data-test-id": "serverValueLabel"
      }, AbReactResources.field_serverValueName()), props.serverValue ? props.valueRenderer(props.serverValue) : /*#__PURE__*/React.createElement("div", null, AbReactResources.field_nullPreviousValue()));
    }
  }
  return null;
}
export function AbDataValueAccessorTooltipContent(props) {
  const serverValue = props.accessor.getServerValue?.(props.subject) ?? undefined;
  const baselineValue = props.accessor.getBaselineValue?.(props.subject) ?? undefined;
  const hasServerChange = props.accessor.hasServerChange?.(props.subject);
  const hasClientChange = props.accessor.hasClientChange?.(props.subject);
  return AbDataValueTooltipContent({
    serverValue,
    baselineValue,
    hasServerChange,
    hasClientChange,
    valueRenderer: props.valueRenderer
  });
}
//# sourceMappingURL=AbDataValueTooltipContent.js.map
